import styled, { css } from 'styled-components';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
import { NAVIGATION_VIEWPORT_BREAKPOINTS } from '../../../constants';
import { NavigationFlyoutColumnElement } from '../../NavigationFlyoutColumn/styles/navigation-flyout-column.styled';
const NAVIGATION_COLUMN_WIDTH_MEDIUM = 238;
const NAVIGATION_COLUMN_WIDTH_LARGE = 306;
export const navigationFlyoutRowElementStyles = ({ theme }) => css `
	display: flex;
	flex-direction: column;
	gap: ${pxToRem(theme.spacing['100'])};

	@media (min-width: ${pxToRem(NAVIGATION_VIEWPORT_BREAKPOINTS.lg)}) {
		flex-direction: row;
		gap: ${pxToRem(theme.spacing['400'])};

		/* equally divide the available space between the columns */
		${NavigationFlyoutColumnElement} {
			width: ${pxToRem(NAVIGATION_COLUMN_WIDTH_MEDIUM)};
		}

		@media (min-width: ${pxToRem(NAVIGATION_VIEWPORT_BREAKPOINTS.xl)}) {
			${NavigationFlyoutColumnElement} {
				width: ${pxToRem(NAVIGATION_COLUMN_WIDTH_LARGE)};
			}
		}
	}
`;
export const NavigationFlyoutRowElement = styled.div `
	${navigationFlyoutRowElementStyles}
`;
